export const getYearFromDate = (): number => {
  const date = new Date()
  return date.getFullYear()
}
